<template>
  <div class="my-1">
    <div v-for="(autom, indexAutom) in automations" :key="indexAutom">
      <div v-if="selectedAutomation < 0 || selectedAutomation === indexAutom">
        <div id="values" class="d-flex flex-row align-items-center py-1">
          <div class="col px-0 mr-2">
            <b-input v-model="autom.nome" :placeholder="$lang.PCI.Items.Automation.PlaceholderName" class="mr-2" :disabled="selectedAutomation < 0"/>
          </div>
          <div class="col-md-2 pr-0">
            <b-checkbox v-model="autom.automatico" switch :disabled="selectedAutomation < 0">{{$lang.PCI.Items.Automation.LabelAutomatic}}</b-checkbox>
          </div>
          <div class="d-flex pr-0 justify-content-end">
            <span v-if="selectedAutomation < 0" class="px-2" v-b-tooltip.hover="$lang.PCI.Items.Tooltip.CloneAutomation">
              <i class="fas fa-clone text-third py-1"
                style="cursor: pointer; font-size: 1rem;"
                @click="onCloneAutomation(autom)">
              </i>
            </span>
            <b-dropdown v-if="selectedAutomation < 0" href="#"
                        variant="link"
                        toggle-class="text-decoration-none p-0"
                        no-caret
                        tabindex="-1"
                        v-b-tooltip.hover
                        :title="$lang.Common.Tooltip.ButtonDelete">
              <template #button-content>
                <i class="fa fa-trash text-danger p-1" style="cursor:pointer"></i>
              </template>
              <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
              <b-dropdown-item href="#" v-on:click="onRemoveAutomation(indexAutom)">{{$lang.Common.Yes}}</b-dropdown-item>
              <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
            </b-dropdown>
            <span v-if="selectedAutomation < 0" class="px-2" v-b-tooltip.hover="$lang.PCI.Items.Tooltip.AddAutomation">
              <i class="fas fa-pen text-primary py-1"
                style="cursor: pointer; font-size: 1rem;"
                @click="onEditAutomation(autom, indexAutom)">
              </i>
            </span>
            <template v-else-if="selectedAutomation === indexAutom">
              <span class="px-2" v-b-tooltip.hover="$lang.Menu.Common.Back">
                <i class="fas fa-undo text-second py-1"
                  style="cursor: pointer; font-size: 1rem;"
                  @click="onCancel()">
                </i>
              </span>
              <span class="px-2" v-b-tooltip.hover="$lang.PCI.Items.Tooltip.SaveAutomation" >
                <!-- <i class="fas fa-save text-third py-1" :clickable="!hasWarnings"
                  style="cursor: pointer; font-size: 1rem;"
                  @click="onSaveAutomation(autom)">
                </i> -->
                <button class="btn p-0 border-0 bg-transparent" :disabled="hasWarnings" @click="onSaveAutomation(autom)">
                  <i class="fas fa-save py-1"
                    :class="hasWarnings ? 'text-muted' : 'text-third'"
                    :style="{ cursor: hasWarnings ? 'not-allowed' : 'pointer' }">
                  </i>
                </button>
              </span>
            </template>
          </div>
        </div>
      </div>
      <div class="col-md-12 mb-3" v-if="selectedAutomation === indexAutom">
        <div class="d-flex flex-row flex-wrap align-items-center"
             v-for="(val, indexVal) in value.valores"
             :key="indexVal">
          <div class="col-md-10"
               @click="onEditValue(val, indexVal)"
               v-b-tooltip.hover="$lang.PCI.Items.Tooltip.AddAutomation">
            <b-input v-model="val.valor" class="col mr-2" readonly style="cursor: pointer"/>
          </div>
          <span class="col px-2"
                v-if="hasRules(val)"
                v-b-tooltip.hover="$lang.PCI.Items.Tooltip.EditAutomation">
            <i class="fas fa-check text-primary py-1"></i>
          </span>
          <div class="col-md-10">
            <add-validation-automation :itemList="itemList"
                                       :value="editValue"
                                       tipo="AUTOMATION"
                                       v-if="selectedValue === indexVal"
                                       @Create="onCreateAutomationRule"
                                       @Clean="onClearAutomationRule"
                                       @validation-warning="hasWarnings = $event"
                                       @changeList="onChangeList">
            </add-validation-automation>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-row align-items-center py-1" v-if="selectedAutomation < 0">
      <b-input :placeholder="$lang.PCI.Items.Automation.PlaceholderNewName"
               v-model="newAutomation"
               class="mr-2">
      </b-input>
      <i class="fa fa-plus-circle text-third p-1"
         style="cursor: pointer; font-size: 1rem;"
         @click="onNewAutomation">
      </i>
    </div>
  </div>
</template>

<script>
import ItemTreeView from '../components/treeview/ItemTreeView.vue'
import actionsForm from '@/shared/mixins/actionsForm'
import addAutomation from './addAutomation-form'
import AddValidationAutomation from './addValidationAutomation'
import CompanyMixin from '@/store/module/company/mixin'
import itemMixim from '../mixins/itemMixim'
import { uuid } from 'uuidv4'
import { loading, toast } from '@/shared/utils/UIHelper'
import PCIItemRepository from '@/shared/http/repositories/pci/pciItem'
import { cloneDeep } from 'lodash'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'

export default {
  name: 'AddAutomation',
  props: {
    value: Object,
    itemList: Array
  },
  mixins: [ actionsForm, CompanyMixin, itemMixim ],
  components: {
    ItemTreeView,
    AddValidationAutomation
  },
  data () {
    return {
      automations: [],
      form: addAutomation,
      newAutomation: null,
      selectedAutomation: -1,
      selectedValue: -1,
      editAutomation: null,
      editValue: null,
      hasWarnings: false
    }
  },
  methods: {
    hasRules (val) {
      const rules = this.editAutomation.statusValores.filter(sv => sv.pciModeloItemValorID === val.id)[0]
      return rules && rules.regrasStatus && rules.regrasStatus.length
    },
    onLoad () {
      loading.push()
      PCIItemRepository.GetAllAutomations(this.value.id)
        .then(response => {
          if (response.data.code > 0) {
            this.automations = response.data.data
          }
        })
        .finally(() => loading.close())
    },
    onNewAutomation () {
      const data = {
        id: '00000000-0000-0000-0000-000000000000',
        pciModeloItemID: this.value.id,
        nome: this.newAutomation,
        mensagem: null,
        alertaGrupoID: null,
        travaEdicao: false,
        status: 1
      }
      this.automations.push(data)
      this.newAutomation = null
      const index = this.automations.length - 1
      this.onEditAutomation(this.automations[index], index)
    },
    onRemoveAutomation (index) {
      if (this.automations[index].id === '00000000-0000-0000-0000-000000000000') {
        this.automations.splice(index, 1)
      } else {
        loading.push()
        return PCIItemRepository.DeleteAutomation(this.automations[index].id)
          .then(response => {
            if (response.data.code > 0) {
              this.automations.splice(index, 1)
              toast.success(this.$lang.Common.Alerts.Success)
            } else {
              toast.error(this.$lang.Common.Alerts.Error)
            }
            loading.close()
          })
          .catch(err => {
            console.log(err)
            this.onException(err)
          })
      }
    },
    onEditAutomation (automation, index) {
      if (this.selectedAutomation === index) {
        this.selectedAutomation = -1
      } else {
        if (!automation.statusValores) {
          automation.statusValores = []
        }
        this.editAutomation = automation
        this.selectedAutomation = index
      }

      this.selectedValue = -1
    },
    onCloneAutomation (automation) {
      const clonedAutomation = cloneDeep(automation)

      clonedAutomation.id = uuid()

      let counter = 1
      const usedNames = this.automations.map(a => a.nome)

      while (usedNames.includes(clonedAutomation.nome)) {
        clonedAutomation.nome = `${automation.nome} (${counter})`
        counter++
      }

      clonedAutomation.statusValores = clonedAutomation.statusValores.map(sv => {
        sv.id = uuid()
        const fromTo = {}
        sv.regrasStatus = sv.regrasStatus.map(rs => {
          const newId = uuid()
          fromTo[rs.id] = newId
          rs.id = newId

          if (fromTo[rs.pciModeloItemStatusRegraIDPai]) {
            rs.pciModeloItemStatusRegraIDPai = fromTo[rs.pciModeloItemStatusRegraIDPai]
          }
          return rs
        })

        return sv
      })

      this.automations.push(clonedAutomation)
    },
    onCreateAutomationRule (automation) {
      this.editValue.regrasStatus.push(automation)
    },
    onClearAutomationRule () {
      this.selectedValue = -1
      this.editValue = null
      this.hasWarnings = false
    },
    onEditValue (value, index) {
      if (this.selectedValue === index) {
        this.selectedValue = -1
      } else {
        const editValue = this.automations[this.selectedAutomation].statusValores.filter(sv => sv.pciModeloItemValorID === value.id)[0]

        if (editValue) {
          if (!editValue.regrasStatus) {
            editValue.regrasStatus = []
          }
          this.editValue = editValue
        } else {
          this.editValue = {
            id: uuid(),
            pciModeloItemStatusID: this.editAutomation.id,
            pciModeloItemValorID: value.id,
            regrasStatus: []
          }
          this.automations[this.selectedAutomation].statusValores.push(this.editValue)
        }
        this.selectedValue = index
      }
    },
    onSaveAutomation (autom) {
      loading.push()
      PCIItemRepository.UpdateAutomation(autom)
        .then(response => {
          if (response.data.code > 0) {
            // PCIItemRepository.GetAllAutomations(this.value.id, {params: { pciModeloItemStatusId: response.data.data.id }})
            WorkPCIRepository.AutomatizationByItem(response.data.data.id)
            this.onLoad()
            toast.success(this.$lang.Common.Alerts.Success)
            this.selectedAutomation = -1
            this.selectedValue = -1
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
          loading.close()
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
    },
    onCancel () {
      this.selectedAutomation = -1
      this.selectedValue = -1
      this.hasWarnings = false
    },
    onChangeList (objList) {
      this.$set(this.automations[this.selectedAutomation], 'regrasStatus', objList)
      console.table(this.automations[this.selectedAutomation].regrasStatus)
    }
  }
}
</script>

<style scoped>
#values {
  padding-bottom: 0.2em;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/items/addAutomation.vue